import React from "react";
import { useNavigate } from "react-router-dom";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { Table, TableHeader, TableBody, TableRow, TableCell } from "../../../components/tables";
import { useCustomers } from "../hooks";

interface IProps {
  categoryId: number;
  limit?: number;
}

export const CustomersList: React.FC<IProps> = ({ categoryId, limit }) => {
  const navigate = useNavigate();
  const { data, loading } = useCustomers({ where: { categoryId } });

  if (loading) return <Loading />;

  const results = data?.customers?.results ?? [];
  const visibleResults = limit ? results.slice(0, limit) : results;
  const total = data?.customers?.total ?? results.length;

  if (!visibleResults.length) {
    return <EmptyList text="Aucun client" />;
  }

  return (
    <div>
      <Table>
        <TableHeader>
          <TableRow hover={false}>
            <TableCell header>Nom</TableCell>
            <TableCell header align="center">
              Prix seul
            </TableCell>
            <TableCell header align="center">
              Fiche complète
            </TableCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          {visibleResults.map((customer) => (
            <TableRow
              key={`customer-${customer.id}`}
              onClick={() => navigate(`/customer/${customer.id}`)}
            >
              <TableCell>{customer.name}</TableCell>
              <TableCell align="center">{customer.priceOnly ? "Oui" : "Non"}</TableCell>
              <TableCell align="center">
                {customer.isComplete ? (
                  <span className="inline-block px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-700">
                    Complète
                  </span>
                ) : (
                  <span className="inline-block px-2 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-700">
                    Incomplète
                  </span>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {limit && total > limit && (
        <div className="mt-3 text-right">
          <span
            className="text-indigo-600 text-sm cursor-pointer hover:underline"
            onClick={() => navigate(`/customers?categoryId=${categoryId}`)}
          >
            Voir tous les clients ({total})
          </span>
        </div>
      )}
    </div>
  );
};
